import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Cell, Grid, Select } from '@fs/zion-ui'
import { usePageView } from '@fs/zion-analytics'
import { css } from '@emotion/core'
import { usePageTitle } from '../../app/PageTitleContext'
import OdmRecordForm from './odmRecord/OdmRecordForm'
import OdmSubmissionForm from './OdmSubmissionForm'
import OdmiRecordForm from './odmiRecord/OdmiRecordForm'
import OdmRecordsView from './odmRecord/OdmRecordsView'
import OdmSubmissionView from './OdmSubmissionView'
import OdmiRecordsView from './odmiRecord/OdmiRecordsView'

export default function OdvSearch({ history, location }) {
  usePageView({ page_detail: 'DMConsole:OdvSearch' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.search.odv'))
  const searchParams = new URLSearchParams(location.search)
  const datasetParam = searchParams.get('search')

  const [dataset, setDataset] = useState('odmRecords')
  const [odmRecordQuery, setOdmRecordQuery] = useState()
  const [odmSubmissionQuery, setOdmSubmissionQuery] = useState()
  const [odmiQuery, setOdmiQuery] = useState()

  const boldLabel = css`
    label {
      font-weight: bold;
    }
  `

  useEffect(() => {
    if (datasetParam && datasetParam !== dataset) {
      setDataset(datasetParam)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search])

  const onOdmRecordSearch = (query) => {
    setOdmRecordQuery(query)
  }

  const onOdmSubmissionSearch = (query) => {
    setOdmSubmissionQuery(query)
  }

  const onOdmiRecordSearch = (query) => {
    setOdmiQuery(query)
  }

  const handleDatasetChange = (value) => {
    setDataset(value)
    setOdmRecordQuery(null)
    setOdmSubmissionQuery(null)
    setOdmiQuery(null)
    history.push(`/search/odv?search=${value}`)
  }

  return (
    <span css={boldLabel}>
      <Grid>
        <Cell columns={2}>
          <Select
            id="odvSearchOptions"
            label={t('odv.datasets', 'Datasets')}
            value={dataset}
            hidePlaceholder
            onChange={(event) => handleDatasetChange(event.target.value)}
            options={[
              { value: 'odmRecords', label: t('odv.odmRecords', 'ODM Records') },
              { value: 'odmSubmission', label: t('odv.odmSubmissions', 'ODM Submissions') },
              { value: 'china', label: t('odm.type.odmic', 'ODMi Chinese') },
              { value: 'korea', label: t('odm.type.odmik', 'ODMi Korean') },
              { value: 'japan', label: t('odm.type.odmij', 'ODMi Japanese') },
              { value: 'cyrillic', label: t('odm.type.odmif', 'ODMi Cyrillic') },
            ]}
          />
        </Cell>
      </Grid>
      {dataset === 'odmRecords' && (
        <OdmRecordForm handleSubmit={onOdmRecordSearch} location={location} history={history} />
      )}
      {dataset === 'odmSubmission' && (
        <OdmSubmissionForm handleSubmit={onOdmSubmissionSearch} location={location} history={history} />
      )}
      {!dataset?.startsWith('odm') && (
        <OdmiRecordForm handleSubmit={onOdmiRecordSearch} language={dataset} location={location} history={history} />
      )}
      {odmRecordQuery && <OdmRecordsView odmRecordQuery={odmRecordQuery} />}
      {odmSubmissionQuery && <OdmSubmissionView submissionQuery={odmSubmissionQuery} />}
      {odmiQuery && <OdmiRecordsView odmiQuery={odmiQuery} country={dataset} />}
    </span>
  )
}
